'use client';

import { useCallback } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import CinematicScene from './CinematicScene';
import { tryCtaScrollToFinal } from '../lib/tryNavigation';

export default function Scene05Mascot() {
  const reduced = useReducedMotion() ?? false;

  const goToFinal = useCallback(() => {
    tryCtaScrollToFinal();
  }, []);

  const goToCategories = useCallback(() => {
    document.getElementById('scene-categories')?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <CinematicScene imageAlt="Маскот Favbox летит над морем сохранённых заметок" imageSrc="/landing/110526/1.webp" imagePriority>
      <h2
        className="font-display font-bold text-white tracking-[-0.02em] leading-[0.96] mb-6"
        style={{ fontSize: 'clamp(2rem, 5.5vw, 3.75rem)', textShadow: '0 4px 24px rgba(0,0,0,0.4)' }}
      >
        Favbox<br />
        <span className="text-[#f5a85a]">превращает сохранёнки</span> в каталог.
      </h2>
      <p
        className="font-body text-white/85 text-base sm:text-lg leading-relaxed mb-6 max-w-md"
        style={{ textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}
      >
        Ты выбираешь полку одним нажатием, а я подтяну обложки, помогу разобрать накопленное и подкину идею, когда захочется.
      </p>

      {/* Отстройка от конкурентов */}
      <p
        className="font-body text-white/65 text-[13px] sm:text-sm leading-relaxed mb-8 max-w-md italic"
        style={{ textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}
      >
        Не заметки в Notion и избранном. Не закладки в браузере. Favbox — помощник, который доводит до результата.
      </p>

      <div className="flex flex-col items-start gap-5">
        <button
          type="button"
          onClick={goToFinal}
          className="group relative inline-flex items-center gap-2.5 px-7 py-4 rounded-2xl bg-[#b7102a] hover:bg-[#991020] active:scale-[0.98] text-white font-semibold text-base transition-all cursor-pointer font-body"
          style={{ boxShadow: '0 16px 40px -8px rgba(183,16,42,0.55)' }}
        >
          <span>Попробовать сейчас</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover:translate-x-0.5">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </button>

        {/* Secondary — "Подробнее" со стрелкой вниз */}
        <button
          type="button"
          onClick={goToCategories}
          className="group inline-flex items-center gap-2 text-white/80 hover:text-white font-body text-sm font-medium transition-colors"
          style={{ textShadow: '0 2px 8px rgba(0,0,0,0.35)' }}
        >
          <span>Подробнее</span>
          <motion.svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            animate={reduced ? {} : { y: [0, 4, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
          >
            <path d="M12 5v14M19 12l-7 7-7-7" />
          </motion.svg>
        </button>
      </div>
    </CinematicScene>
  );
}
